var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.875 0.59375C6.58324 0.59375 5.32049 0.976801 4.24643 1.69446C3.17238 2.41213 2.33525 3.43217 1.84091 4.6256C1.34658 5.81903 1.21724 7.13225 1.46925 8.39918C1.72126 9.66612 2.3433 10.8299 3.25671 11.7433C4.17012 12.6567 5.33388 13.2787 6.60082 13.5308C7.86776 13.7828 9.18097 13.6534 10.3744 13.1591C11.5678 12.6648 12.5879 11.8276 13.3055 10.7536C14.0232 9.67951 14.4063 8.41676 14.4063 7.125C14.4063 5.39281 13.7181 3.73156 12.4933 2.50671C11.2684 1.28186 9.6072 0.59375 7.875 0.59375ZM10.25 7.71875H7.875C7.71753 7.71875 7.56651 7.65619 7.45516 7.54484C7.34381 7.4335 7.28125 7.28247 7.28125 7.125V3.5625C7.28125 3.40503 7.34381 3.25401 7.45516 3.14266C7.56651 3.03131 7.71753 2.96875 7.875 2.96875C8.03247 2.96875 8.1835 3.03131 8.29485 3.14266C8.4062 3.25401 8.46875 3.40503 8.46875 3.5625V6.53125H10.25C10.4075 6.53125 10.5585 6.59381 10.6698 6.70516C10.7812 6.8165 10.8438 6.96753 10.8438 7.125C10.8438 7.28247 10.7812 7.4335 10.6698 7.54484C10.5585 7.65619 10.4075 7.71875 10.25 7.71875Z",
    fill: "#303030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ee04897d7e25f066313d708b8ccf8472.svg";
export { ForwardRef as ReactComponent };